/**
 * @file input module
 * @author
 * title: string，名称
 * isMsgRequired: boolean，是否必填项
 * validCode：function，校验规则
 */
import React from 'react';

import LabelFormItem from '../LabelFormItem/index';
import Input from 'antd/lib/input';
import {
    ExclamationCircleOutlined
} from '@ant-design/icons';
import './index.less';
const {TextArea} = Input;

interface Props {
    type: string;
    title: string;
    isMsgRequired: boolean;
    data: any;
    updateData?: any;
    style: {};
    maxLength?: number;
    placeholder?:string;
    disabled?: boolean;
    onChange?:any;
    onBlur?:any;
}

export default function TextAreaFormItem(props: Props) {
    const {
        type,
        disabled,
        title,
        isMsgRequired,
        data,
        updateData,
        placeholder,
        onChange,
        onBlur,
        style,
        maxLength
    } = props;

    const onInputChange = (e:{target: {value: string}}) => {
        updateData && updateData({
            [type]: e.target.value,
            [type + 'Err']: ''
        });
        onChange && onChange(e);
    };

    const onInputBlur = (e:{target: {value: string}}) => {
        updateData && updateData({
            [type]: e.target.value,
            [type + 'Err']: ''
        });
        onBlur && onBlur(e);
    };

    return (
        <div className={'form-item-textarea'}>
            {title && <LabelFormItem isMsgRequired={isMsgRequired} title={title} />}
            <div className={'form-item-textarea-box'}>
                <TextArea
                    className={
                        data[type + 'Err']
                            ? 'form-item-textarea-content border-error'
                            : 'form-item-textarea-content'
                    }
                    showCount={!!maxLength}
                    maxLength={maxLength || 40}
                    rows={3}
                    style={style}
                    value={data[type]}
                    disabled={disabled}
                    placeholder={placeholder}
                    onChange={onInputChange}
                    onBlur={onInputBlur}
                />
                {data[type + 'Err'] && <p className="form-item-textarea-err">
                    <ExclamationCircleOutlined style={{marginRight: '4px'}} />
                    {data[type + 'Err']}</p>}
            </div>

        </div>
    );
}
